import React, { useEffect } from 'react'
import NavbarV2 from '../components/navbar-v2'
import CuzAlPanel from '../components/cuz-al-panel'
import CounterSection from '../components/counter-section'
import FaqV2 from '../components/faq-v2'
import DownloadV2 from '../components/download-v2'
import FooterV2 from '../components/footer-v2'
import ScrollToTopV2 from '../components/scroll-to-top-v2'

// Custom theme overrides (renk paleti)
import '../assets/css/custom-theme.css'

export default function IndexV2() {
    useEffect(() => {
        // WOW.js benzeri scroll animasyonları için
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -100px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                }
            });
        }, observerOptions);

        // Tüm .wow elementlerini gözlemle
        document.querySelectorAll('.wow').forEach((el) => {
            observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <>
            {/* Navbar */}
            <NavbarV2 />

            {/* Cüz Al: gruplar ve cüz seçimi doğrudan ana sayfada */}
            <CuzAlPanel />

            <main className="ht-site">
            {/* Counter/Stats Section */}
            <CounterSection />

            {/* FAQ Section */}
            <FaqV2 />

            {/* Download/CTA Section */}
            <DownloadV2 />
            </main>

            {/* Footer */}
            <FooterV2 />

            {/* Scroll to Top Button */}
            <ScrollToTopV2 />
        </>
    );
}
